import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Button from '@components/Button'

class ExpertStatusChangeComment extends Component {
  static propTypes = {
    modalStore: PropTypes.object.isRequired,
    expertStore: PropTypes.object.isRequired,
    commentStore: PropTypes.object.isRequired,
    title: PropTypes.string,
    commentPrefix: PropTypes.string
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: true,
    shouldCloseOnOverlayClick: false
  }

  constructor(props) {
    super(props)

    extendObservable(this, {
      statusChangeComment: '',
      isSubmitting: false
    })
  }

  buildErrorGrowlProps = type => {
    return {
      title: 'Error!',
      message: `${type} is required.`,
      type: 'error',
      autoClose: true
    }
  }

  toggleExpertStatus = () => {
    const { commentStore, expertStore, commentPrefix, modalStore } = this.props
    this.isSubmitting = true

    if (!Number(expertStore.expert.id)) {
      const { growlStore } = expertStore
      if (
        !expertStore.expert.email &&
        !expertStore.expert.address?.emails?.length
      ) {
        growlStore.addNotification(this.buildErrorGrowlProps('Email'))
      } else {
        expertStore
          .addSherlockRule({
            comment: this.statusChangeComment,
            contactType: 'all',
            scope: 'global',
            source: 'manual',
            sourceService: 'sherlock',
            type: 'email',
            validFrom: '2020-01-01',
            validTo: '2100-01-01',
            value: expertStore.expert.email
          })
          .then(() => {
            this.isSubmitting = false
            expertStore.get(expertStore.expert.id)
            modalStore.close()
          })
      }
    } else {
      expertStore
        .changeExpertStatus({
          commentPrefix,
          statusChangeComment: this.statusChangeComment
        })
        .then(() => {
          const expertId = expertStore.expert.id

          commentStore.load(expertId, 'expert').then(() => {
            modalStore.close()
            expertStore.get(expertId)
            this.isSubmitting = false
          })
        })
    }
  }

  render() {
    const wrapperClasses = classNames({
      'expert-form__input-wrapper': true
    })
    return (
      <div className="expert-form">
        <h1 className="expert-form__title">
          {this.props.title || 'Status change comment'}
        </h1>
        <div className="expert-form__input-group">
          <label className="expert-form__label">
            Add status change comment
          </label>
          <div className={wrapperClasses}>
            <div>
              <textarea
                onChange={e => (this.statusChangeComment = e.target.value)}
                value={this.statusChangeComment}
                className="expert-form__input"
                type="textarea"
                rows="5"
              />
            </div>
          </div>
        </div>
        <div className="expert-form__section p-b-0">
          <div className="iconWrapper">
            <Button
              primary
              submit
              onClick={() => this.toggleExpertStatus()}
              disabled={!this.statusChangeComment || this.isSubmitting}>
              Save
            </Button>
          </div>
          <div className="inline m-l-lg">
            <Button onClick={this.props.modalStore.close}>Cancel</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default inject('modalStore')(observer(ExpertStatusChangeComment))
